import styled, { css } from 'styled-components';
import { modernViewportUnit, pxToRem } from '@anwb/style-utilities';
const MAX_POPOVER_HEIGHT = 660;
const getTopOfPopover = ({ top, offset }) => {
    return pxToRem(top + 1 + offset);
};
const getBottomOfPopover = ({ bottom, offset }) => {
    return pxToRem(bottom - 1 - offset);
};
const getOffsetSpacing = ({ direction, offset, theme }) => {
    if (!offset)
        return 0;
    if (direction === 'up') {
        return Number(theme.spacing[offset]) * -1;
    }
    return Number(theme.spacing[offset]);
};
export const PopoverContainer = styled.div `
	position: relative;
	display: inline-block;
`;
export const popoverWrapperStyles = ({ theme }) => css `
	z-index: ${Number(theme.zIndex.popUp) + 1};
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: ${modernViewportUnit(100, 'dvh')};
	background-color: ${theme.colors.dark.overlayPopover};
`;
export const PopoverWrapper = styled.div `
	${popoverWrapperStyles}
`;
const popoverContentContainerStyles = ({ theme, $direction, top, bottom, left, offset, }) => {
    const topOfPopover = getTopOfPopover({
        top,
        offset: getOffsetSpacing({ direction: $direction, offset, theme }),
    });
    const bottomOfPopover = getBottomOfPopover({
        bottom,
        offset: getOffsetSpacing({ direction: $direction, offset, theme }),
    });
    return css `
		@keyframes show {
			from {
				opacity: 0;
			}

			to {
				opacity: 1;
			}
		}

		z-index: ${Number(theme.zIndex.popUp) + 2};
		position: absolute;

		${$direction === 'down' &&
        css `
			top: ${topOfPopover};
		`}
		max-height: min(${modernViewportUnit(100, 'dvh')} - ${topOfPopover}, ${pxToRem(MAX_POPOVER_HEIGHT)});

		${$direction === 'up' &&
        css `
			bottom: ${bottomOfPopover};
			max-height: min(
				${modernViewportUnit(100, 'dvh')} - ${bottomOfPopover},
				${pxToRem(MAX_POPOVER_HEIGHT)}
			);
		`}

		left: ${pxToRem(left || 0)};
		overflow-y: scroll;
		overscroll-behavior: contain;
		border-radius: ${pxToRem(theme.borderRadius.m)};
		box-shadow: ${pxToRem(theme.boxShadow.popover.x)} ${pxToRem(theme.boxShadow.popover.y)}
			${pxToRem(theme.boxShadow.popover.blur)} ${pxToRem(theme.boxShadow.popover.spread)}
			${theme.boxShadow.popover.color};
		background-color: ${theme.colors.blanc.bgPopover};

		/* prevent slight flicker when useLayoutEffect passes 0 */
		opacity: 0;
		animation: show 0ms 0.2ms linear forwards;
	`;
};
export const PopoverContentContainer = styled.div `
	${popoverContentContainerStyles}
`;
//# sourceMappingURL=popover.styled.js.map